import React, { useEffect } from "react";
import HomeSection from "./components/HomeSection";
import About from "./components/about";
import Features from "./components/features";
import Header from "./components/navbar";
import Price from "./components/price";
import ScreenShot from "./components/screenshot";
import Team from "./components/team";
import Testimonial from "./components/testimonial";
import Work from "./components/work";
import FAQ from "./components/faq";
import Blog from "./components/blog";
import Download from "./components/download";
import Contact from "./components/contact";
import Subscribe from "./components/subscribe";
import Footer from "./components/footer";
import TapTop from "./common/TapTop";

const Home = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");    
  }, []);

  
  return (
    <div>
      
      <Header />
       
      <HomeSection />
    
      <About />
       
      <Features />

      <Work />

      <ScreenShot />

      <Team />

      <Price />

      <Testimonial />

      <FAQ />

      <Blog />

      <Download />

      <Contact />

      <Subscribe />

      <Footer />

     <TapTop/>
    </div>
  );
};

export default Home;
